import PieChartComponent from 'components/PieChart';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';

const ExternalTooltipContent = ({ percent, value, colorName, name }) => {
  return (
    <Flex width='19rem'>
      <Icon name='cube' size='x=small' color={colorName} />
      <Text size='small' pl='0.5rem' color='shuttleGray'>
        {percent}% - {name} ({value} code changes)
      </Text>
    </Flex>
  );
};

const WorkBreakdownChart = ({ workBreakdownData, isEmptyData = false }) => {
  return (
    <Flex direction='column'>
      <Flex items='center' direction='column'>
        <Flex>
          <PieChartComponent
            noStroke
            showTooltip={false}
            showExternalTooltip={!isEmptyData}
            externalTooltipContent={ExternalTooltipContent}
            data={workBreakdownData}
            pieSize={{ width: 120, height: 120 }}
            pieLine={20}
            paddingAngle={0}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default WorkBreakdownChart;
